import Api from "./Api";

class UserApi extends Api {
  getList(data: object) {
    const url = this.prepareUrl("disclosurecode/user/list/");
    return this.requestGetList(url, data);
  }

  getTotal(data: object) {
    const url = this.prepareUrl("disclosurecode/user/list/");
    data = { ...data, getTotal: true };
    return this.requestGetList(url, data, "total");
  }

  get(id: number, data: object) {
    const url = this.prepareUrl("/disclosurecode/user/get/", id);
    return this.requestGet(url, data, "object");
  }

  getCurrent(data: object): Promise<object> {
    const url = this.prepareUrl("/disclosurecode/user/get/");
    return this.requestGet(url, data, "object");
  }

  logout(data?: object) {
    const url = this.prepareUrl("/disclosurecode/user/logout/");
    return this.requestGet(url, data || {}, "success");
  }
}

export default new UserApi();
